import {
  SET_CURRENT_PARTICIPATION,
  // UPDATE_CURRENT_PARTICIPATION,
} from './types'

// API
import * as API  from '../utils/api';

export const setCurrentParticipation = (participationId) => dispatch => {
  return new Promise((resolve, reject) => {
    API.getParticipation(participationId)
    .then(participation => {
      let responseObject = {
        success: true
      }

      dispatch(setParticipation(participation))
      resolve(responseObject)
    }).catch(error => {
      console.log('there was an error: ', error);
    })
  })
}

const setParticipation = (participation) => ({
  type: SET_CURRENT_PARTICIPATION,
  participation
});

export const updateCurrentParticipation = (user, username, profile) => dispatch => {
  return new Promise((resolve, reject) => {
    let responseObject = {
      success: true
    }

    // dispatch(updateParticipation(participation))
    resolve(responseObject)
  })
}

// const updateParticipation = (participation) => ({
//   type: UPDATE_CURRENT_PARTICIPATION,
//   participation
// });


// WEBPACK FOOTER //
// ./src/actions/locker.js